import React, { useState } from "react";
import { Card, CardContent, Grid, Box, useTheme } from "@mui/material";
import {
  TrendingUp,
  TrendingDown,
  MonetizationOn,
  Receipt,
  AccountBalance,
} from "@mui/icons-material";
import Header from "./Header";
import { formatDecimal } from "../../../hooks/Method";
export default function ProfitLossReport() {
  const theme = useTheme();
  const [values, setValues] = useState({});

  const summaryCards = [
    {
      title: "Total Revenue",
      value: values?.totalRevenue,
      color: "#4caf50",
      icon: <TrendingUp fontSize="medium" />,
    },
    {
      title: "Cost of Goods Sold (COGS)",
      value: values?.totalCogs,
      color: "#ff9800",
      icon: <TrendingDown fontSize="medium" />,
    },
    {
      title: "Gross Profit",
      value: values?.grossProfit,
      color: "#2196f3",
      icon: <MonetizationOn fontSize="medium" />,
    },
    {
      title: "Operating Expenses",
      value: values?.totalExpenses,
      color: "#f44336",
      icon: <Receipt fontSize="medium" />,
    },
    {
      title: "Net Profit",
      value: values?.netProfit,
      color: "#9c27b0",
      icon: <AccountBalance fontSize="medium" />,
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <Header {...{ setValues }} />

      <Grid container spacing={3}>
        {summaryCards.map((card, idx) => (
          <Grid item xs={12} sm={6} md={3} key={idx}>
            <Card
              sx={{
                p: 1.5,
                borderLeft: `4px solid ${card.color}`,
                backgroundColor:
                  theme.palette.mode === "light"
                    ? "#fff"
                    : theme.palette.background.paper,
                borderRadius: 3,
              }}
            >
              <CardContent sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1.5} mb={0.5}>
                  <Box color={card.color}>{card.icon}</Box>
                  <span className="text-[14px] font-medium text-gray-500">
                    {card.title}
                  </span>
                </Box>
                <span className="text-[22px] font-semibold text-gray-600">
                  $ {formatDecimal(card.value || 0, true)}
                </span>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
